import 'es6-promise/auto';
import 'babel-polyfill';
import D2Kit from '@devsquared/d2kit';
import Vue from 'vue';
import VueEditor from 'vue2-editor';
import {
  D2Vuex, setupD2Auth, setupD2Vuex, NamespacedActionNames,
} from '@devsquared/vuex';
import { SchedulePlugin } from '@syncfusion/ej2-vue-schedule';
import { FormatMixin, DotnetMixin } from '@devsquared/d2kit/src/js/mixins';

Vue.use(SchedulePlugin);

Vue.use(D2Vuex);
const store = setupD2Vuex(require.context('~/Resources/scripts/store/modules', false, /\.(js|ts)$/));
setupD2Auth(store);

Vue.config.productionTip = false;
Vue.mixin(DotnetMixin);
Vue.mixin(FormatMixin);
Vue.use(VueEditor);

Vue.use(D2Kit);

const resourceFiles = require.context('~/Resources', true, /\.vue$/i);
const viewFiles = require.context('~/Views', true, /\.vue$/i);

// eslint-disable-next-line
resourceFiles.keys().map((key) => {
  const component = resourceFiles(key).default;
  if (component.parent) {
    Vue.component(key.split('/').pop().split('.')[0], resourceFiles(key).default);
  }
});

// eslint-disable-next-line
viewFiles.keys().map((key) => {
  const component = viewFiles(key).default;
  if (component.parent) {
    Vue.component(key.split('/').pop().split('.')[0], viewFiles(key).default);
  }
});

const elem = document.getElementById('loadCover');
elem.parentNode.removeChild(elem);

const vueApp = new Vue({
  store,
});

// Set the D2Auth States
store.dispatch(NamespacedActionNames.SET_USER_PROFILE, window.user);
store.dispatch(NamespacedActionNames.SET_ROLES, window.roles);
store.dispatch(NamespacedActionNames.SET_CLAIMS, window.claims);
store.dispatch(NamespacedActionNames.SET_CURRENT_COMPANY, window.company);

vueApp.$mount('#vue-wrapper');